module.exports = __webpack_public_path__ + "static/media/paper25.13ed4733.jpg";